module.exports = __webpack_public_path__ + "img/diners.4ab28c3c.png";